/* ===========================
   AboveAVL Custom JS
   - Hide header on scroll down, show on scroll up
   - Hide sticky ATC bar when header menu is open
   - Re-enable RFQ button when app loads late
   =========================== */

/* 1) Sticky header hide/show */
(function () {
  let lastY = window.scrollY;
  let ticking = false;

  const threshold = 10;   // ignore tiny deltas
  const showOffset = 70;  // always show near top
  const minYToHide = 140; // don't hide immediately

  function getHeader() {
    // Prefer the active sticky state if it exists
    return (
      document.querySelector('.header__sticky.sticky') ||
      document.querySelector('.header__sticky')
    );
  }

  function update() {
    const header = getHeader();
    if (!header) { ticking = false; return; }

    const y = window.scrollY;
    const delta = y - lastY;

    // Always visible near top
    if (y < showOffset) {
      header.classList.remove('avl-header--hidden');
      lastY = y;
      ticking = false;
      return;
    }

    if (Math.abs(delta) > threshold) {
      if (y > minYToHide && delta > 0) {
        header.classList.add('avl-header--hidden');   // scrolling down
      } else if (delta < 0) {
        header.classList.remove('avl-header--hidden'); // scrolling up
      }
      lastY = y;
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();


/* 2) If header menu is open, add body class so CSS can hide sticky ATC bar */
(function () {
  function headerMenuIsOpen() {
    // Any open <details> within the header regions = menu open
    return !!document.querySelector(
      'header details[open], .header__sticky details[open], .header__inner details[open]'
    );
  }

  function syncMenuState() {
    document.body.classList.toggle('avl-menu-open', headerMenuIsOpen());
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMenuState, { once: true });
  } else {
    syncMenuState();
  }

  // Listen for <details> open/close inside the header
  const headerRoot =
    document.querySelector('header') ||
    document.querySelector('.header__sticky') ||
    document.querySelector('.header__inner');

  if (headerRoot) {
    headerRoot.addEventListener('toggle', function (e) {
      if (e.target && e.target.tagName === 'DETAILS') syncMenuState();
    }, true);
  }

  // Safety on resize
  window.addEventListener('resize', syncMenuState, { passive: true });
})();


/* 3) RFQ button unlock: handle late-loading app + dynamic cart updates */
(function () {
  function rfqReady() {
    return (window.GRFQApp && typeof window.GRFQApp.addProductsCart === 'function');
  }

  function enableRfqButtons() {
    if (!rfqReady()) return false;

    const buttons = document.querySelectorAll('.rfq-btn-cart');
    if (!buttons.length) return false;

    buttons.forEach(function (btn) {
      btn.style.pointerEvents = 'auto';
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
    });

    return true;
  }

  // Run on load
  function init() {
    // Try immediately
    if (enableRfqButtons()) return;

    // Retry briefly (apps often inject after DOMContentLoaded)
    let tries = 0;
    const maxTries = 60;  // ~6 seconds
    const timer = setInterval(function () {
      tries++;
      if (enableRfqButtons() || tries >= maxTries) clearInterval(timer);
    }, 100);

    // Re-run on Shopify section/cart updates
    document.addEventListener('shopify:section:load', enableRfqButtons);
    document.addEventListener('shopify:section:reorder', enableRfqButtons);

    // Targeted observer: only watch the cart + main content regions if present
    const targets = [];
    const cartCandidates = [
      document.querySelector('cart-drawer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('#MainContent')
    ].filter(Boolean);

    cartCandidates.forEach((t) => targets.push(t));

    if (targets.length) {
      const obs = new MutationObserver(function () { enableRfqButtons(); });
      targets.forEach((t) => obs.observe(t, { childList: true, subtree: true }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();